// removed by extract-text-webpack-plugin
module.exports = {"link-more":"t0eTA","linkMore":"t0eTA","link-more-normal":"QvTa_","linkMoreNormal":"QvTa_","link-more-light":"_2zFMJ","linkMoreLight":"_2zFMJ","mobile":"_21ZGx","desktop":"g12Dk"};